import { createAction, props, union } from '@ngrx/store';

import { RefundsStatus } from '../../interfaces/store.interface';
import { RefundCase } from '../../interfaces/refunds.interface';

export const setRefunds = createAction(
  '[RefundsActions] SetRefunds',
  props<{ refunds: RefundCase[]; status: RefundsStatus }>()
);
export const resetRefunds = createAction('[RefundsActions] ResetRefunds');

const _all = union({ setRefunds, resetRefunds });
export type RefundsActionsUnion = typeof _all;
